import { Injectable } from '@angular/core';
import {
    ActionBarContext,
    addActionBarItem,
    addNavMenuSection,
    DataService,
    getServerLocation,
    NotificationService,
    registerBulkAction,
} from '@vendure/admin-ui/core';
import axios from 'axios';
import gql from 'graphql-tag';
import { catchError, Observable, of } from 'rxjs';
import { reTargetCustomerBulkAction } from './components/customers-active-list/customers-active-list-bulk-actions';

interface DeleteUserSessions {
    deleteUserSessions: boolean;
}

@Injectable()
class MyService {
    constructor(private readonly dataService: DataService) { }

    deleteUserSessions(): Observable<DeleteUserSessions> {
        const mutation = gql`
            mutation DeleteUserSessions {
                deleteUserSessions
            }
        `;
        return this.dataService.mutate<DeleteUserSessions>(mutation).pipe(
            catchError(error => {
                throw error;
            }),
        );
    }
}
export default [
    MyService,
    addNavMenuSection(
        {
            id: 'customers-analysis',
            label: 'Customers Analysis',
            requiresPermission: (userPermissions) => userPermissions.includes('SuperAdmin') && userPermissions.includes('CreatePromotion'),
            items: [
                {
                    id: 'customers-active-list',
                    label: 'Customers Analysis',
                    routerLink: ['/extensions/customers-list/active-list'],
                    icon: 'person',
                },
            ],
        },
        'customers',
    ),
    registerBulkAction(reTargetCustomerBulkAction),
    addActionBarItem({
        id: 'delete-user-sessions',
        locationId: 'global-setting-detail',
        label: 'Delete User Sessions',
        icon: 'check',
        requiresPermission: 'SuperAdmin',
        buttonColor: 'success',
        onClick: async (event: MouseEvent, context: ActionBarContext) => {
            const myService = context.injector.get(MyService);
            const notificationService = context.injector.get(NotificationService);
            myService.deleteUserSessions().subscribe({
                next: response => {
                    const status = response.deleteUserSessions;
                    if (status) {
                        notificationService.success('Job initiated to Clear User Sessions.');
                    } else {
                        notificationService.error(`Error occurred Clearing User Sessions.`);
                    }
                },
                error: () => {
                    notificationService.error('Error occurred Clearing User Sessions.');
                },
            });
        },
    }),
    addActionBarItem({
        id: 'sync-customers-with-marketing',
        locationId: 'customer-list',
        label: 'Sync With Marketing',
        icon: 'sync',
        requiresPermission: 'SuperAdmin',
        buttonColor: 'success',
        onClick: async (event: MouseEvent, context: ActionBarContext) => {
            const notificationService = context.injector.get(NotificationService);
            const serverPath = getServerLocation();

            axios
                .get(`${serverPath}/scripts/customers/sync-with-marketing`, {
                    headers: {
                        Authorization: '709fcc3d-d549-41f1-8a75-959ad49f4b6c',
                    },
                })
                .then(({ data }) => {
                    notificationService.success(`Sync Customers: ${data.message}`);
                })
                .catch(err => {
                    notificationService.error('Error occurred syncing customers with marketing.');
                });
        },
    }),
];
